import type { SVGProps } from "react";
const SvgLogoDoorRightNew = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={567.999}
    height={164.001}
    fill="none"
    fillRule="evenodd"
    stroke="#000"
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    strokeWidth={0.501}
    fontFamily="Times New Roman"
    fontSize={16}
    overflow="visible"
    style={{
      fontVariantLigatures: "none",
    }}
    viewBox="0 -750 425.999 123.001"
    {...props}
  >
    <g stroke="none">
      <path fill="#514b44" d="M422.999-750v123.001H0v-.01L122.999-750z" />
      <path fill="#262626" d="M425.999-750v123.001H3v-.01L125.999-750z" />
      <g
        fill="#f7e5c5"
        fillRule="nonzero"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={0.416}
      >
        <path d="M149.364-714.107q0-.672-.28-.952t-1.064-.28h-21.056q-1.344 0-1.904-.504t-.56-1.96v-5.712q0-1.456.56-1.96t1.904-.504h56q1.344 0 1.904.504t.56 1.96v5.712q0 1.456-.56 1.96t-1.904.504h-21.056q-.784 0-1.064.28t-.28.952v64.064q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96zM196.989-723.515q0-1.456.56-1.96t1.904-.504h6.272q1.344 0 1.904.504t.56 1.96v29.12q0 .672.28 1.008t1.064.336h37.072q.784 0 1.064-.336t.28-1.008v-29.12q0-1.456.56-1.96t1.904-.504h6.272q1.344 0 1.904.504t.56 1.96v73.472q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96v-31.248q0-.672-.28-.952t-1.064-.28h-37.072q-.784 0-1.064.28t-.28.952v31.248q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96zM302.936-721.835q1.568-3.36 2.52-4.48t2.072-1.12 2.016 1.12 2.464 4.48l33.712 70.896q.56 1.344.56 1.904 0 1.456-2.352 1.456h-6.16q-1.792 0-2.632-.616t-1.736-2.52l-8.624-18.816q-.336-.896-.728-1.12t-1.288-.224h-30.8q-.896 0-1.288.224t-.84 1.12l-8.512 18.816q-.896 1.904-1.736 2.52t-2.632.616h-5.712q-2.352 0-2.352-1.456 0-.56.56-1.904zm15.12 41.104q1.232 0 1.232-.672 0-.336-.336-1.008l-11.648-25.088-11.536 25.088q-.336.672-.336 1.12 0 .56 1.12.56zM367.107-714.107q0-.672-.28-.952t-1.064-.28h-21.056q-1.344 0-1.904-.504t-.56-1.96v-5.712q0-1.456.56-1.96t1.904-.504h56q1.344 0 1.904.504t.56 1.96v5.712q0 1.456-.56 1.96t-1.904.504h-21.056q-.784 0-1.064.28t-.28.952v64.064q0 1.456-.56 1.96t-1.904.504h-6.272q-1.344 0-1.904-.504t-.56-1.96z" />
      </g>
    </g>
  </svg>
);
export default SvgLogoDoorRightNew;
